<template>
  <div class="form-container" style="position: relative">
    <el-form ref="form" label-position="top" :rules="rules" :model="formLabelAlign" label-width="80px" class="order-form">
      <el-row :gutter="5">
        <el-col :span="8">
          <el-form-item :label="$t('email')" style="width: 100%">
            <el-input class="gray-theme" v-model="formLabelAlign.email" :disabled="disabled"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('cellphone')" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.telephone" :disabled="disabled"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="line-h1"></div>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('product')" style="width: 100%">
            <el-input class="gray-theme" v-model="formLabelAlign.productName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="line-h1"></div>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('active_date')" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.createdTimeTemp" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('expire_date')" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.deadlineTemp" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('user_qty')" style="width: 100%">
            <el-input class="gray-theme" v-model.number="formLabelAlign.maxUserNumber" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
// import { EventBus } from '../../../../common/eventBus/eventbus';
import userApi from '@/apis/user';
export default {
  data() {
    return {
      formLabelAlign: {
        id: '',
        cellphone: '',
        email: '',
        address: '',
        month: '',
        maxUserNumber: '',
        version: '',
        name: '',
        groupName: ''
      },
      disabled: false,
      listData: [],
      Product: '',
      rules: {}
    };
  },

  props: {
    itemErpList: {
      type: Object,
      default: () => {}
    },

    addNewForm: {
      type: Boolean,
      default: false
    }

  },

  components: {},

  computed: {},

  mounted() {
    this.init();
    this.getUser();
  },

  methods: {
    init() {
      this.formLabelAlign = { ...this.itemErpList };
      this.formLabelAlign.createdTimeTemp = this.formLabelAlign.createdTime.split(
        ' '
      )[0];
      this.formLabelAlign.deadlineTemp = this.formLabelAlign.deadline.split(
        ' '
      )[0];
    },

    async getUser() {
      const req = {};
      const res = await userApi.getUserInfo(req);
      if (res.type === 10) {
        this.disabled = true;
      }
    }
  }
};
</script>
<style lang="scss">
.middle-container {
  .el-form--label-left {
    background-color: #fff;
    padding: 0 165px;
    overflow: auto;
    // height: 560px;
    // max-height: 560px;
    padding-top: 40px;
  }

  .el-select {
    display: block;
    position: relative;
  }

  .el-select > .el-input {
    display: inline-block;
  }
}

.buy-info {
  color: #292929;
  font-weight: bold;
  font-size: 24px;
  text-align: left;
}

.line-h1 {
  height: 1px;
  background: #c7c8c9;
  width: 100%;
  margin: 20px 0;
}

.dialog-footer {
  display: block;
  height: 80px;
  line-height: 80px;
}

.order-form {
  .el-form-item__label {
    float: left;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    color: #292929;
    padding: 0;
  }

  .el-form-item__content {
    text-align: left;
    .el-textarea__inner {
      height: 80px;
    }
  }
}

.wi-100 {
  .el-form-item__content {
    width: 100%;
  }
}
</style>
